import React from "react";

import {
    StyleSheet,
    View
} from 'react-native';


import AppTheme from "../../../shared/utils/Theme";


const LiliWebView = (props: any) => {

    const appTheme: AppTheme = new AppTheme();

    // MainOptions
    const { url, } = props;

    const closeTheDocument = () => {
        if (props.closeTheDocument !== undefined) {
            props.closeTheDocument();
        }
    }

    const onBuffer = () => {

    }

    const onError = () => {

    }

    const onEnd = () => {
    }

    return (
        <View />
    )
}

export default LiliWebView;

const styles = StyleSheet.create({
    backgroundVideo: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
    },
});